(function () {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  async function getState() {
    const [cartResponse, settingsResponse] = await Promise.all([
      fetch(root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'}),
      fetch(root + 'cart?section_id=couchery-cart-data', {cache:'no-store'})
    ]);
    if (!cartResponse.ok || !settingsResponse.ok) throw new Error('Could not check your configuration. Please refresh the cart.');
    const cart = await cartResponse.json();
    const html = new DOMParser().parseFromString(await settingsResponse.text(), 'text/html');
    const raw = html.querySelector('[data-couchery-cart-settings]');
    if (!raw) throw new Error('Configuration settings could not be loaded.');
    const settings = JSON.parse(raw.textContent);
    return {cart, settings, errors:[...CoucheryOptions.inspectCart(cart, settings.configurations, settings.addonProducts),...(window.CoucherySwatches?.inspectCart(cart)||[])]};
  }
  window.CoucheryCart = {getState};
  document.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link || new URL(link.href,location.href).pathname !== root + 'cart' || new URL(link.href,location.href).search) return;
    event.preventDefault(); event.stopImmediatePropagation();
    location.assign(root + 'cart');
  }, true);
  let checking = false;
  function showError(error) {
    let message = document.querySelector('[data-couchery-checkout-error]');
    if (!message) { message = document.createElement('p'); message.setAttribute('role','alert'); message.dataset.coucheryCheckoutError=''; message.style.cssText='padding:16px;background:#fff1e8;color:#6f3b27;border:1px solid #ddc2b2;position:fixed;bottom:20px;left:20px;right:20px;z-index:10000'; document.body.append(message); }
    message.textContent = error;
  }
  async function checkout(event) {
    event.preventDefault(); event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      const state = await getState();
      if (state.errors.length) throw new Error(state.errors.join(' ') + ' Return to the configuration cart to update or remove the sofa.');
      window.location.assign(root + 'checkout');
    } catch (error) { showError(error.message); checking = false; }
  }
  // Applies to ordinary checkout controls in the unpublished trial theme.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href$="/checkout"], [data-couchery-checkout]')) checkout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkout(event);
  }, true);
  if (!customElements.get('couchery-configuration-cart')) customElements.define('couchery-configuration-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.list = this.querySelector('.co-cart-items'); this.status = this.querySelector('.co-cart-status'); this.total = this.querySelector('.co-cart-grand-total');
      this.refresh();
    }
    money(value) { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.currency || 'USD'}).format(value/100); }
    async refresh() {
      try { this.state = await getState(); this.currency = this.state.cart.currency; this.render(); }
      catch (error) { this.status.textContent = error.message; }
    }
    render() {
      const cart = this.state.cart; this.list.replaceChildren();
      this.status.textContent = this.state.errors.join(' ');
      this.querySelector('[data-couchery-checkout]').disabled = cart.items.length === 0 || this.state.errors.length > 0;
      this.total.textContent = this.money(cart.total_price);
      const discounts = this.querySelector('.co-cart-discounts');
      if (discounts) {
        discounts.replaceChildren();
        const amount = cart.items.reduce((sum,item) => sum + item.final_line_price, 0) - cart.total_price;
        if (amount > 0) {
          const line = document.createElement('p'); line.className = 'co-cart-line';
          const label = document.createElement('span'); label.textContent = (cart.cart_level_discount_applications || []).map(discount => discount.title).join(', ') || discounts.dataset.label;
          const value = document.createElement('span'); value.textContent = '−' + this.money(amount);
          line.append(label,value); discounts.append(line);
        }
      }
      const parents = cart.items.filter(item => !item.parent_relationship?.parent_key);
      for (const parent of parents) {
        const children = cart.items.filter(item => item.parent_relationship?.parent_key === parent.key);
        const box = document.createElement('article'); box.className = 'co-cart-card';
        const heading = document.createElement('h2'); heading.textContent = parent.product_title; box.append(heading);
        const variant = document.createElement('p'); variant.textContent = parent.variant_title || ''; box.append(variant);
        for (const [key,value] of Object.entries(parent.properties || {})) if (!key.startsWith('_') && value) { const p=document.createElement('p');p.className='co-help';p.textContent=key+': ';if(/^https:\/\/(cdn\.shopify\.com|[^/]+\.myshopify\.com)\//.test(String(value))){const a=document.createElement('a');a.href=value;a.textContent=key;a.target='_blank';a.rel='noopener';p.append(a);}else{p.append(document.createTextNode(String(value)));}box.append(p); }
        const charge = (label,price) => {const p=document.createElement('p');p.className='co-cart-line';const name=document.createElement('span');name.textContent=label;const amount=document.createElement('span');amount.textContent=this.money(price);p.append(name,amount);box.append(p);};
        charge(this.dataset.baseLabel, parent.final_line_price);
        for (const child of children) charge((child.variant_title || child.product_title) + (Number(child.properties?._couchery_units || 1) > 1 ? ' × ' + child.quantity : ''), child.final_line_price);
        if (this.state.settings.configurations[String(parent.product_id)] && !parent.properties?._couchery_selections) {
          const note = document.createElement('p'); note.className = 'co-help'; note.textContent = this.dataset.configureNote;
          const configure = document.createElement('a'); configure.href = root + 'products/' + encodeURIComponent(parent.handle) + '?variant=' + parent.variant_id; configure.textContent = this.dataset.configureLabel;
          box.append(note,configure);
        }
        const controls=document.createElement('div');controls.className='co-cart-controls';
        const label=document.createElement('label');label.textContent=this.dataset.quantityLabel;const input=document.createElement('input');input.type='number';input.min='1';input.max='20';input.value=String(parent.quantity);label.append(input);
        const update=document.createElement('button');update.type='button';update.textContent=this.dataset.updateLabel;update.addEventListener('click',()=>this.change(parent,children,Number(input.value)));
        const remove=document.createElement('button');remove.type='button';remove.textContent=this.dataset.removeLabel;remove.addEventListener('click',()=>this.change(parent,children,0));controls.append(label,update,remove);box.append(controls);this.list.append(box);
      }
    }
    async change(parent,children,quantity) {
      if (this.busy) return;
      if (!Number.isInteger(quantity) || quantity < 0 || quantity > 20) {this.status.textContent='Quantity must be between 1 and 20.';return;}
      this.busy=true;this.querySelectorAll('button').forEach(button=>button.disabled=true);
      try {
        const updates={};
        // Parent deletion automatically removes nested children in Shopify.
        updates[parent.key]=quantity;
        if (quantity>0) children.forEach(child=>updates[child.key]=quantity * Number(child.properties?._couchery_units || 1));
        const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
        const result=await response.json();if(!response.ok)throw new Error(result.description || 'Could not update your cart.');
        await this.refresh();
      }catch(error){this.status.textContent=error.message;this.querySelectorAll('button').forEach(button=>button.disabled=false);}
      finally{this.busy=false;}
    }
  });
})();

